import React from 'react';
import type { AppliedEffectDTO } from '@hexcrawl/shared-utils';

interface Props {
  effects: AppliedEffectDTO[];
}

// Keyed by the effect `type` as the server emits it (snake_case, e.g. "modify_gold").
const EFFECT_ICONS: Record<string, string> = {
  modify_gold: '🪙',
  modify_hp:   '❤️',
  modify_mp:   '🔵',
};

export const EffectDisplay: React.FC<Props> = ({ effects }) => {
  if (!effects.length) return null;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      marginBottom: 16,
    }}>
      {effects.map((effect, i) => {
        const icon = EFFECT_ICONS[effect.type] ?? '✦';
        const color = effect.positive ? '#66ff99' : '#ff6666';
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: effect.positive ? 'rgba(102,255,153,0.08)' : 'rgba(255,102,102,0.08)',
              border: `1px solid ${effect.positive ? '#336644' : '#663333'}`,
              borderRadius: 4,
              padding: '4px 10px',
              fontSize: 13,
              color,
              fontFamily: 'monospace',
            }}
          >
            <span>{icon}</span>
            <span>{effect.message}</span>
          </div>
        );
      })}
    </div>
  );
};
